import { styled } from '@linaria/react';

import { SubHeadline } from '~components/Typography';

export const RatingContainer = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: space-between;
	gap: var(--gap-x2);
`;

export const RatingItemTitle = styled(SubHeadline)`
	white-space: nowrap;
`;

export const RatingItem = styled.label`
	position: relative;
	width: 56px;
	aspect-ratio: 1 / 1;
	cursor: pointer;
`;

export const RatingItemRadio = styled.input`
	position: absolute;
	left: 0;
	opacity: 0;

	& ~ img {
		transition: filter 0.2s, transform 0.2s;
	}

	&:checked {
		& ~ p {
			color: var(--color-white-solid);
			opacity: 1;
			transform: translateY(0);
		}
	}

	&:not(:checked) {
		& ~ img {
			filter: grayscale(1);
			transform: scale(0.8);
		}
	}
`;
